/** Pale parchment, the local player's health-bar rim (SHE-35): the game's « this one » colour. */
export const HOVER_COLOR = 0xf0e6c8;

/** Pixels each corner bracket runs along its two sides. */
const ARM = 2;

/**
 * The four corner brackets around a drop's drawing (SHE-36), as [x, y, width, height]
 * runs of whole pixels, one pixel clear of it. The drawing is centred on x = 0 and
 * stands on y = 0, `width` wide and `height` tall, like `DropView` draws it.
 */
export function hoverFrame(width: number, height: number): [number, number, number, number][] {
  const left = -Math.floor(width / 2) - 2;
  const top = -height - 2;
  const right = left + width + 3; // last column, inclusive
  const bottom = 1; // last row, inclusive
  return [
    // top-left
    [left, top, ARM, 1],
    [left, top, 1, ARM],
    // top-right
    [right - ARM + 1, top, ARM, 1],
    [right, top, 1, ARM],
    // bottom-left
    [left, bottom, ARM, 1],
    [left, bottom - ARM + 1, 1, ARM],
    // bottom-right
    [right - ARM + 1, bottom, ARM, 1],
    [right, bottom - ARM + 1, 1, ARM],
  ];
}
